import React from 'react';

import html from '../../content/information/LiquorLicensingLaws';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import HtmlContentScreen from '../common/HtmlContentScreen';

const LiquorLicensingLawsScreen = (
  _: RouteNavigatorScreenProps<AppRoute.RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS>,
) => <HtmlContentScreen html={html} />;

export default LiquorLicensingLawsScreen;
